import styled from 'styled-components';
import { BigCheckIcon, CheckIcon } from '../icon/icon';

export const ComplateFormFailed = () => {
  return (
    <Wrap>
      <div className="icon-box">
        <BigCheckIcon />
      </div>
      <p>조회된 아이디가 없습니다.</p>
      <span>확인 후 다시 이용바랍니다.</span>
    </Wrap>
  );
};

export const ComplateFormSuccess = () => {
  return (
    <Wrap>
      <div className="icon-box">
        <CheckIcon />
      </div>
      <p>바밀번호가 변경되었습니다.</p>
      <span>로그인 후 이용바랍니다.</span>
    </Wrap>
  );
};

//style
const Wrap = styled.div`
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .icon-box {
    display: flex;
    margin-bottom: 2.4rem;
  }
  p {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.8rem;
  }
  span {
    display: flex;
    font-size: 1.4rem;
    color: ${(props) => props.theme.textAAAColor};
  }
`;
